import axios from 'axios'
import queryString from 'query-string'

import { ERROR_MESSAGE_DELETING_FILE, ERROR_MESSAGE_DOWNLOADING_FILE, ERROR_MESSAGE_SAVING } from '../constants'
import { reportFileUploadError } from '../helpers/sentry'
import { formatFileUploadErrorMessage, formatFileUploadSuccessMessage, truncateTextMiddle } from '../helpers/strings'
import { receiveSuccessAlert } from './alerts'
import { handleRequestError } from './request'

export const DELETE_QUARTERLY_TAX_RETURN_FILE = 'DELETE_QUARTERLY_TAX_RETURN_FILE'
export const DOWNLOAD_QUARTERLY_TAX_RETURN_FILE = 'DOWNLOAD_QUARTERLY_TAX_RETURN_FILE'
export const RECEIVE_QUARTERLY_TAX_RETURN_FILES = 'RECEIVE_QUARTERLY_TAX_RETURN_FILES'
export const REMOVE_AND_DELETE_QUARTERLY_TAX_RETURN_FILE = 'REMOVE_AND_DELETE_QUARTERLY_TAX_RETURN_FILE'
export const REMOVE_QUARTERLY_TAX_RETURN_FILE = 'REMOVE_QUARTERLY_TAX_RETURN_FILE'
export const REQUEST_QUARTERLY_TAX_RETURN_FILES = 'REQUEST_QUARTERLY_TAX_RETURN_FILES'
export const SAVE_QUARTERLY_TAX_RETURN_FILE = 'SAVE_QUARTERLY_TAX_RETURN_FILE'
export const UPDATE_AND_SAVE_QUARTERLY_TAX_RETURN_FILE = 'UPDATE_AND_SAVE_QUARTERLY_TAX_RETURN_FILE'
export const UPLOAD_QUARTERLY_TAX_RETURN_FILE = 'UPLOAD_QUARTERLY_TAX_RETURN_FILE'

export const requestQuarterlyTaxReturnFiles = (quarterlyTaxReturnId) => (dispatch) => {
    dispatch({ type: REQUEST_QUARTERLY_TAX_RETURN_FILES, data: { quarterlyTaxReturnId } })

    axios
        .get(`/quarterlytaxreturnfiles?quarterlyTaxReturnId=${quarterlyTaxReturnId}`)
        .then((response) => {
            const items = response?.data || []
            dispatch(receiveQuarterlyTaxReturnFiles({ items, fetchSuccessful: true, isFetching: false }))
        })
        .catch((error) => {
            dispatch(receiveQuarterlyTaxReturnFiles({ fetchSuccessful: false, isFetching: false }))

            dispatch(handleRequestError(error))
        })
}

export const receiveQuarterlyTaxReturnFiles = (data) => ({ type: RECEIVE_QUARTERLY_TAX_RETURN_FILES, data })

export const uploadQuarterlyTaxReturnFile = (data) => (dispatch, getState) => {
    dispatch({ type: UPLOAD_QUARTERLY_TAX_RETURN_FILE, data })

    const { quarterlyTaxReturn } = getState()

    const { file, fileSubType, fileType, quarterlyTaxReturnId } = data

    const params = {
        quarterlyTaxReturnId: quarterlyTaxReturnId || quarterlyTaxReturn.id,
        fileSubType: fileSubType || '',
        fileType: fileType || '',
    }

    const formData = new FormData()
    formData.append('file', file)

    axios
        .post(`/quarterlytaxreturnfiles?${queryString.stringify(params)}`, formData, {
            headers: {
                'content-type': 'multipart/form-data',
            },
        })
        .then(() => {
            dispatch(receiveSuccessAlert(formatFileUploadSuccessMessage(file?.name)))

            dispatch(requestQuarterlyTaxReturnFiles(quarterlyTaxReturnId || quarterlyTaxReturn.id))
        })
        .catch((error) => {
            reportFileUploadError(error, file)
            dispatch(handleRequestError(error, { customMessage: formatFileUploadErrorMessage(file?.name) }))
        })
}

export const removeAndDeleteQuarterlyTaxReturnFile =
    (data, options = {}) =>
    (dispatch) => {
        dispatch({ type: REMOVE_AND_DELETE_QUARTERLY_TAX_RETURN_FILE, data })

        dispatch(removeQuarterlyTaxReturnFile(data))
        dispatch(deleteQuarterlyTaxReturnFile(data, options))
    }

export const removeQuarterlyTaxReturnFile = (data) => ({ type: REMOVE_QUARTERLY_TAX_RETURN_FILE, data })

export const deleteQuarterlyTaxReturnFile =
    (data, { hideAlert = false } = {}) =>
    (dispatch) => {
        dispatch({ type: DELETE_QUARTERLY_TAX_RETURN_FILE, data })

        const { id, fileName } = data

        axios
            .delete(`/quarterlytaxreturnfiles/${id}`)
            .then(() => {
                dispatch(removeQuarterlyTaxReturnFile({ id }))

                if (!hideAlert) {
                    dispatch(
                        receiveSuccessAlert(`Archivo ${fileName ? `"${truncateTextMiddle(fileName)}"` : ''} eliminado`)
                    )
                }
            })
            .catch((error) => {
                dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_DELETING_FILE }))
            })
    }

export const updateAndSaveQuarterlyTaxReturnFile = (data) => (dispatch) => {
    dispatch({ type: UPDATE_AND_SAVE_QUARTERLY_TAX_RETURN_FILE, data })

    dispatch(receiveQuarterlyTaxReturnFiles({ items: [data] }))
    dispatch(saveQuarterlyTaxReturnFile(data))
}

export const saveQuarterlyTaxReturnFile = (data) => (dispatch) => {
    dispatch({ type: SAVE_QUARTERLY_TAX_RETURN_FILE, data })

    const { id } = data

    axios
        .put(`/quarterlytaxreturnfiles/${id}`, data)
        .then((response) => {
            const item = response?.data

            if (!item) return

            dispatch(receiveQuarterlyTaxReturnFiles({ items: [item] }))
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
        })
}

export const downloadQuarterlyTaxReturnFile = (data) => (dispatch) => {
    dispatch({ type: DOWNLOAD_QUARTERLY_TAX_RETURN_FILE, data })

    const { id } = data

    return axios
        .get(`/quarterlytaxreturnfiles/${id}/downloadlink`)
        .then((response) => {
            if (!response?.data) {
                return Promise.reject()
            }

            window.location.assign(response.data)
            return Promise.resolve()
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_DOWNLOADING_FILE }))
        })
}
